import script from "./WareHousesView.vue?vue&type=script&setup=true&lang=js"
export * from "./WareHousesView.vue?vue&type=script&setup=true&lang=js"

import "./WareHousesView.vue?vue&type=style&index=0&id=25f0e3e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25f0e3e2"]])

export default __exports__